
const ErrorPage = () => {
  return (
    <div className='titleText'>Error: Page Not Found</div>
  )
}

export default ErrorPage